import React from "react"
import MessagesContainer from "#/pages/in-app-messaging"
import { ConsumerMessagesPage } from "#/pages/consumer/messages/page"
import { useMemberProgramFlags } from "#/services/user/hooks/useMemberProgram"
import { PageLoading } from "#/features/global-ui/page-layout"

export function MessagesRoute(): JSX.Element {
  const { data: programFlags, isLoading, isError } = useMemberProgramFlags()
  if (isLoading || isError || !programFlags) return <PageLoading />
  return programFlags.isConsumer ? <ConsumerMessagesPage /> : <MessagesContainer />
}
